var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0003 5C13.5111 5 11.5559 6.93676 11.5559 9.25C11.5559 11.5632 13.5111 13.5 16.0003 13.5C18.4895 13.5 20.4449 11.5632 20.4449 9.25C20.4449 6.93676 18.4895 5 16.0003 5ZM9.55591 9.25C9.55591 5.76425 12.4758 3 16.0003 3C19.525 3 22.4449 5.76425 22.4449 9.25C22.4449 12.7357 19.525 15.5 16.0003 15.5C12.4758 15.5 9.55591 12.7357 9.55591 9.25ZM19.5553 19.9579C17.2002 19.5696 14.8005 19.5696 12.4454 19.9579L12.1684 20.0036C9.59877 20.4272 7.66699 22.7303 7.66699 25.482C7.66699 26.3512 8.34098 27 9.1045 27H22.8962C23.6597 27 24.3337 26.3512 24.3337 25.482C24.3337 22.7303 22.4019 20.4272 19.8323 20.0036L19.5553 19.9579ZM19.8806 17.9845L20.1577 18.0301C23.7393 18.6207 26.3337 21.7987 26.3337 25.482C26.3337 27.394 24.825 29 22.8962 29H9.1045C7.17562 29 5.66699 27.394 5.66699 25.482C5.66699 21.7987 8.26143 18.6207 11.843 18.0301L12.1201 17.9845C14.6906 17.5607 17.3101 17.5607 19.8806 17.9845Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetails);
export default __webpack_public_path__ + "static/media/personalDetails.2d81424aa7779ae6a5301d2a9d6395db.svg";
export { ForwardRef as ReactComponent };